"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Toggle_base_1 = require("./Toggle.base");
var Toggle_styles_1 = require("./Toggle.styles");
exports.Toggle = Utilities_1.styled(Toggle_base_1.ToggleBase, Toggle_styles_1.getStyles, undefined, { scope: 'Toggle' });
//# sourceMappingURL=Toggle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Toggle/Toggle.js
// module id = 1230
// module chunks = 0